import FeatureCard from "./feature-card/feature-card";
import syncArrows from "@/assets/images/icons/sync_arrows.svg"
import voucherPercent from "@/assets/images/icons/voucher_percent.svg"
import starCheck from "@/assets/images/icons/star_check.svg"
import { useScrollReveal } from "@/hooks/useScrollReveal";

export function HomeAbout() {
    const { ref: headerRef, visible: headerVisible } = useScrollReveal(0.1);
    const { ref: cardsRef, visible: cardsVisible } = useScrollReveal(0.1);

    return (
        <div className="w-full dot-grid">
        <div className="text-white max-w-[1200px] mx-auto px-6 pt-16 md:pt-16 ">
            <div
                ref={headerRef}
                className="flex flex-col items-center text-center mb-16 gap-4 transition-all duration-700"
                style={{
                    opacity: headerVisible ? 1 : 0,
                    transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
                }}
            >
                <h2 className="text-4xl lg:text-5xl font-bold font-roboto leading-tight">
                    Επιβραβεύουμε<br className="hidden sm:block" /> την κάθε σου αγορά
                </h2>
                <p className="text-white/50 text-lg max-w-xl">
                    Το PADU σου επιστρέφει σε κάθε αγορά δώρα και αποκλειστικές προσφορές από αγαπημένα brands, πάντα και παντού.
                </p>
            </div>
            <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 cursor-pointer items-stretch">
                {[
                    { icon: syncArrows, title: "Ανταμοιβή σε κάθε αγορά", description: "Κέρδισε PADU points και δωροεπιταγές από τις καθημερινές σου αγορές!", link: "/antamoivi-se-kathe-agora" },
                    { icon: voucherPercent, title: "Αποκλειστικές προσφορές", description: "Απόλαυσε αποκλειστικές προσφορές από αγαπημένα brands.", link: "/miniaies-klirosis" },
                    { icon: voucherPercent, title: "Προγράμματα Πιστότητας", description: "Tα loyalty προγράμματα των αγαπημένων σου brands σε μία εφαρμογή.", link: "/programmata-pistotitas" },
                ].map((card, i) => (
                    <div
                        key={card.link}
                        className="transition-all duration-700"
                        style={{
                            opacity: cardsVisible ? 1 : 0,
                            transform: cardsVisible ? 'translateY(0)' : 'translateY(40px)',
                            transitionDelay: `${i * 120}ms`,
                        }}
                    >
                        <FeatureCard
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                            spotlightColor="rgba(0, 229, 255, 0.2)"
                            link={card.link}
                        />
                    </div>
                ))}
            </div>
        </div>
        </div>
    );
}
